import eyerCloud from '@/config/eyercloud'

class ClaimConfigService {

  async get(clinicId) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/get', {clinicId})
    return response.data
  }

  async save(clinicId, overrides, notes) {
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/save', {
      clinicId,
      overrides,
      notes
    })
    return response.data
  }

  async preview(clinicId, {claimCount = 1, overrides = null} = {}) {
    const payload = {clinicId, claimCount}
    if (overrides) payload.overrides = overrides
    const response = await eyerCloud.post('/api/v2/eyercloud/clinic/claim-config/preview', payload)
    return response.data
  }

  async previewExam(examId) {
    const response = await eyerCloud.post('/api/v2/eyercloud/exam/claim-config/preview', {examId})
    return response.data
  }

  async exportBatchClaimsFromExams(params) {
    let response = await eyerCloud.post('/api/v2/eyercloud/claim/export-batch-claims', params)
    return response
  }
}

export default new ClaimConfigService()
